<div
  class="messages"
  celoFileDrop
  [uploader]="uploader"
  (fileOver)="dropZoneState($event)"
  (filesDropped)="handleDrop($event)"
  [ngClass]="{
    valid: dropZoneActive === 'valid',
    gone: !leftChat && uploader && uploader.queue.length !== 0,
  }"
>
  <div class="drop-highlight">
    <div>
      <i class="material-icons icon-xxl">cloud_upload</i>
      <div>UPLOAD</div>
    </div>
  </div>

  <div class="messages-box fh">
    <div
      [ngClass]="{ 'my-backdrop-on': sidenav.opened }"
      (click)="sidenav.close()"
      class="my-backdrop"
    ></div>
    <mat-sidenav-container class="fh">
      <mat-sidenav #sidenav mode="over" position="end">
        <div
          class="header"
          [class.patient-details]="menu === 'patient_details'"
        >
          <div class="title">
            @if (menu === "message_status") {
              <span>Message status</span>
            }
            @if (menu === "message_details") {
              <span>Details</span>
            }
            @if (menu === "role_details") {
              <span>Role Details</span>
            }
            @if (menu === "external_role_details") {
              <span>Details</span>
            }
            @if (menu === "profile_details") {
              <span>Profile</span>
            }
            @if (menu === "admin_settings") {
              <span>{{ type }} admins</span>
            }
            @if (menu === "invite") {
              <span
                >Invite to <span class="lowercase">{{ type }}</span></span
              >
            }
            @if (menu === "search") {
              <span>Search</span>
            }
            @if (menu === "patient_details") {
              <span class="patient-details">Details</span>
            }
          </div>
          <div class="close-button">
            <button
              mat-icon-button
              class="celo-hoverable"
              (click)="sidenav.close()"
            >
              <i class="material-icons-round">close</i>
            </button>
          </div>
        </div>

        @if (menu === "message_status" && selectedMessage) {
          <div class="sidenav-status">
            <app-message-status
              [userAccount]="userAccount"
              [id]="selectedMessage.id"
              [message]="selectedMessage"
              [refreshCount]="refreshCount"
              [conversationType]="type"
              [pMap]="pMap"
              (updateMessage)="updateMessage($event, true)"
            >
            </app-message-status>
          </div>
        }

        @if (menu === "message_details") {
          <div class="sidenav-content">
            <app-message-detail
              [(conversation)]="conversation"
              [participants]="participants"
              [activeAdminList]="activeAdminList"
              (closeClick)="sidenav.close()"
              (leftChatEvent)="leftChat = true"
              (openWindow)="
                menu = $event;
                refreshConversationInfo();
                $event === 'invite' ? generateLinkIfNoLink() : ''
              "
              (isAdmin)="isAdmin = $event"
              [leftChat]="leftChat"
              [type]="type"
              [chatParticipant]="chatParticipant"
              [profileInFocus]="chatParticipantId"
              [userAccount]="userAccount"
              [refreshCount]="refreshCount"
              (userDataChanged)="getChatParticipantApi()"
              (conversationChange)="onNewConversationInfo($event)"
            >
            </app-message-detail>
          </div>
        }
        @if (menu === "role_details") {
          <div class="sidenav-content">
            <app-role-details
              [team]="team"
              [hidePrimaryAction]="true"
              (leaveTeam)="handleLeaveTeam($event)"
              (showProfile)="handleShowTeamMemberProfile($event)"
            ></app-role-details>
          </div>
        }
        @if (menu === "external_role_details") {
          <div class="sidenav-content">
            <app-external-role-details
              [externalUserId]="teamChatParticipant.userId ?? ''"
              [externalName]="teamChatParticipant.firstName ?? ''"
              [externalEmail]="teamChatParticipant.email ?? ''"
              [externalPhoneNumber]="teamChatParticipant.phoneNumber ?? ''"
            ></app-external-role-details>
          </div>
        }
        @if (menu === "profile_details") {
          <div class="sidenav-content">
            <app-message-detail
              [(conversation)]="conversation"
              [showParticipantProfile]="true"
              [profileInFocus]="profileInFocus"
              [userAccount]="userAccount"
              (closeClick)="sidenav.close()"
              (openWindow)="menu = $event; refreshConversationInfo()"
              [type]="type"
            >
            </app-message-detail>
          </div>
        }
        @if (menu === "invite" && type) {
          <div class="sidenav-content">
            <div>
              <div class="section">
                <app-link-share
                  [link]="conversation.invitation.uri"
                  [linkFallback]="'Connect to internet to generate a link'"
                  [title]=""
                  [subtitle]="
                    'Invite your team to this ' +
                    type.toLowerCase() +
                    ' by sharing the ' +
                    type.toLowerCase() +
                    ' invite link. Anyone with the link can join, so share it with people you trust. '
                  "
                  [hideLink]="true"
                  [canReset]="false"
                  [copyButttonText]="
                    'Copy ' + type.toLowerCase() + ' invite link'
                  "
                  [shareBody]="
                    'Follow this link to join the ' +
                    conversation.name +
                    ' ' +
                    type.toLowerCase() +
                    ' on Celo \n' +
                    conversation.invitation.uri
                  "
                  (linkClick)="
                    conversation.invitation.uri
                      ? copy(conversation.invitation.uri)
                      : alertService.connectToInternetSnackbar();
                    linkEvent('details_link')
                  "
                  (copyClick)="
                    conversation.invitation.uri
                      ? copy(conversation.invitation.uri)
                      : alertService.connectToInternetSnackbar();
                    copyEvent('copy_from_details_page')
                  "
                  (shareClick)="
                    shareViaEmail(conversation.invitation.uri);
                    linkEvent('share_button')
                  "
                >
                </app-link-share>
              </div>
              @if (isAdmin) {
                <div class="section">
                  <div class="section-title">Admin Settings</div>
                  @if (conversation.invitation) {
                    <div
                      class="invite-toggle celo-cursor-pointer celo-hoverable"
                      matRipple
                      (click)="toggle()"
                    >
                      <div class="icon">
                        <mat-icon svgIcon="ic-settings"></mat-icon>
                      </div>
                      <div class="texts">
                        <div class="title">
                          Allow all participants to invite
                        </div>
                        <div class="subtitle">
                          @if (!conversation.invitation.allowAll) {
                            <span>Only admins can invite via link</span>
                          }
                          @if (conversation.invitation.allowAll) {
                            <span>All participants can invite via link</span>
                          }
                        </div>
                      </div>
                      <div class="toggle">
                        <mat-slide-toggle
                          #slider
                          hideIcon
                          [checked]="conversation.invitation.allowAll"
                        ></mat-slide-toggle>
                      </div>
                    </div>
                  }
                  <div class="reset-link">
                    <button
                      mat-button
                      class="celo-hoverable"
                      (click)="
                        conversation.invitation.uri
                          ? resetLink(conversation.invitation.uri)
                          : alertService.connectToInternetSnackbar()
                      "
                    >
                      <div class="content">
                        <mat-icon svgIcon="ic-reset"></mat-icon>
                        <div>Reset link</div>
                      </div>
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
        }
        @if (menu === "admin_settings") {
          <div class="sidenav-content">
            <app-admin-settings
              [conversation]="conversation"
              [participants]="activeOtherParticipants"
              (closeClick)="sidenav.close(); onNewConversationInfo($event)"
            ></app-admin-settings>
          </div>
        }
        @if (menu === "search") {
          <div class="fh fw">
            <app-search
              [conversationId]="id"
              [pMap]="pMap"
              [type]="type === 'SelfChat' ? 'Chat' : type"
              [userAccount]="userAccount"
              (selected)="searchSelect($event)"
            >
            </app-search>
          </div>
        }
        @if (menu === "patient_details") {
          <div class="sidenav-content p-0">
            <app-external-chat-details
              [externalUserId]="externalChatParticipant?.userId ?? ''"
              [externalLastName]="conversation?.patientData?.lastName ?? ''"
              [externalFirstName]="conversation?.patientData?.firstName ?? ''"
              [externalDateOfBirth]="
                conversation?.patientData?.dateOfBirth ?? ''
              "
              [externalPhoneNumber]="
                conversation?.patientData?.phoneNumber ?? ''
              "
              [externalUpdateFn]="updatePatientDetails"
              (externalDetails)="onNewPatientDetails($event)"
              [participants]="participants"
              [addParticipantsFn]="addParticipants"
              [conversationId]="$safeNavigationMigration(conversation?.id)"
              (conversationChange)="onNewConversationInfo($event)"
              (closeClick)="sidenav.close()"
            ></app-external-chat-details>
          </div>
        }
      </mat-sidenav>

      <mat-sidenav-content class="relative fh">
        <div class="sidenav-content-container">
          <div class="subject">
            @if (userAccount && userAccount.userId && conversation && type) {
              <app-messages-subject-line
                [userAccount]="userAccount"
                [conversation]="conversation"
                [participantToShow]="chatParticipant"
                [typing]="typing"
                [isOpened]="sidenav.opened"
                [allowedToShowTyping]="allowedToShowTyping"
                [allowedToShowLastOnline]="allowedToShowLastOnline"
                [isRolesTab]="isRolesTab"
                [inProgressCall]="inProgressCall$ | async"
                (infoClick)="openConversationInfo(); sidenav.open()"
                (searchClick)="menu = 'search'; sidenav.open()"
                (closeClick)="sidenav.close(); sidenavClosed()"
              >
              </app-messages-subject-line>
            }
          </div>
          @if (inProgressCall$ | async; as inProgressCall) {
            <div class="incoming-call-bar">
              <app-messages-call-bar
                [call]="inProgressCall"
                (join)="handleJoinCall($event)"
              />
            </div>
          }
          <div class="message-box relative">
            @if (messageId) {
              <div
                class="preview-banner appear_anim_1"
                data-testid="message-preview"
              >
                <div class="text">This is a preview</div>
                <div class="button">
                  <button
                    mat-button
                    class="celo-hoverable"
                    (click)="goToLatest()"
                  >
                    Go to latest message
                  </button>
                </div>
              </div>
            }

            <div #scrollMe (scroll)="onScroll()" class="scroll">
              @if (loadingMore) {
                <div class="loading-more-top">
                  <div class="spinner more">
                    <mat-spinner diameter="20" strokeWidth="2"></mat-spinner>
                  </div>
                </div>
              }
              @if (
                chatParticipant &&
                type === "Chat" &&
                isOnDND &&
                !chatParticipant?.blockedMe?.isBlocked
              ) {
                <div class="dnd-warning appear_1">
                  <div class="content">
                    {{ chatParticipant.firstName }} is set to 'Do not disturb'.
                    This user will still receive your message but will not be
                    notified.
                  </div>
                </div>
              }
              @if (type === "Case") {
                <div class="case-container">
                  <div
                    class="case-info appear_1"
                    data-testid="case-summary"
                    [attr.data-conversation-id]="conversation?.id"
                  >
                    <div class="content">
                      <span>Patient Case</span
                      >{{
                        conversation?.patientData?.uid
                          ? ": " + conversation?.patientData?.uid
                          : ""
                      }}{{
                        conversation?.patientData?.uid &&
                        (conversation?.patientData?.firstName ||
                          conversation?.patientData?.lastName)
                          ? ","
                          : ""
                      }}
                      {{ conversation?.patientData?.firstName }}
                      {{ conversation?.patientData?.lastName }}
                    </div>
                  </div>
                </div>
              }
              @if (
                messageId &&
                !loadingMore &&
                messages[0] &&
                messages[0].type !== "ConversationStarted" &&
                !showHistoryLimitBanner &&
                !initialLoading
              ) {
                <div class="load-more-buttons">
                  <button mat-button (click)="loadMorePrevious()">
                    Load more...
                  </button>
                </div>
              }
              @if (userAccount?.userId && conversation && pMap && messages) {
                <div class="appear_0">
                  @if (showHistoryLimitBanner) {
                    <div
                      class="history-limit-banner"
                      (appOnVisible)="onHistoryLimitBannerVisible()"
                    >
                      <div class="history-limit-text">
                        <div class="history-limit-title">
                          Free plan message history limit reached
                        </div>
                        <div class="history-limit-subtitle">
                          Only the last {{ historyLimitDays }} days of messages
                          are available. Unlock full access to view your
                          complete history.
                        </div>
                      </div>
                      <button
                        mat-raised-button
                        class="history-limit-upgrade"
                        (click)="onHistoryLimitUpgradeClick()"
                      >
                        UPGRADE
                      </button>
                    </div>
                  }
                  <div>
                    @if (
                      messages[0] && messages[0].type === "ConversationStarted"
                    ) {
                      <div>
                        @if (team && type === "TeamChat") {
                          <div class="conversation-cta appear_1">
                            <div
                              class="icon celo-cursor-pointer"
                              (click)="openConversationInfo(); sidenav.open()"
                            >
                              @if (isRolesTab) {
                                <app-celo-avatar
                                  [width]="90"
                                  [height]="90"
                                  [type]="type"
                                  [participant]="teamChatParticipant"
                                  [showBadge]="false"
                                  [badgeSize]="30"
                                  [clickable]="true"
                                  [conversationPictureUri]="
                                    !!conversation.photoId && !leftChat
                                      ? conversationProfileUri
                                      : null
                                  "
                                ></app-celo-avatar>
                              } @else {
                                <app-roles-icon
                                  backgroundSize="90px"
                                  size="72px"
                                ></app-roles-icon>
                              }
                            </div>
                            @if (isRolesTab && teamChatParticipant.isExternal) {
                              <div
                                class="name celo-cursor-pointer"
                                (click)="openConversationInfo(); sidenav.open()"
                              >
                                <div class="name-text underline-on-hover">
                                  {{ name }}
                                </div>
                                <div class="badge-icon">
                                  &nbsp;<app-badge
                                    class="inline-block"
                                    [size]="26"
                                    [isExternal]="true"
                                  ></app-badge>
                                </div>
                              </div>
                            } @else {
                              <div
                                class="name celo-cursor-pointer mb-8"
                                (click)="openConversationInfo(); sidenav.open()"
                              >
                                <div class="name-text underline-on-hover">
                                  {{
                                    isRolesTab && teamChatParticipant
                                      ? teamChatParticipant.firstName +
                                        " " +
                                        teamChatParticipant.lastName
                                      : conversation.name
                                  }}
                                </div>
                              </div>
                            }
                            @if (isRolesTab) {
                              @if (
                                team?.workspace &&
                                !teamChatParticipant.isExternal
                              ) {
                                <div class="subtitle mb-8">
                                  Incoming request for {{ conversation.name }}
                                </div>
                              }
                            } @else {
                              @if (team?.workspace) {
                                <div class="subtitle mb-8">
                                  {{ team.workspace.name }}
                                </div>
                              }
                              @if (team) {
                                <div class="subtitle mb-8">
                                  On Call:
                                  {{ currentUserOnCallName || "Unstaffed" }}
                                </div>
                              }
                            }
                          </div>
                        }
                        @if (type === "Chat" || type === "SelfChat") {
                          <div class="conversation-cta appear_1">
                            <div
                              class="icon celo-cursor-pointer"
                              (click)="openConversationInfo(); sidenav.open()"
                            >
                              <app-celo-avatar
                                [width]="90"
                                [height]="90"
                                [type]="type"
                                [conversationPictureUri]="
                                  !!conversation.photoId && !leftChat
                                    ? conversationProfileUri
                                    : null
                                "
                                [participant]="
                                  chatParticipant ? chatParticipant : ''
                                "
                                [showBadge]="false"
                                [badgeSize]="30"
                                [clickable]="true"
                              ></app-celo-avatar>
                            </div>
                            <div
                              class="name celo-cursor-pointer"
                              (click)="openConversationInfo(); sidenav.open()"
                            >
                              <div class="name-text underline-on-hover">
                                {{ name }}
                                @if (type === "SelfChat") {
                                  <span> (You)</span>
                                }
                              </div>
                              @if (chatParticipant) {
                                <div class="badge-icon">
                                  &nbsp;<app-badge
                                    class="inline-block"
                                    [identityVerificationStatus]="
                                      chatParticipant.identityVerificationStatus
                                    "
                                    [workspaces]="chatParticipant.workplaces"
                                    [profession]="
                                      chatParticipant.professions[0]
                                    "
                                    [size]="26"
                                    [showTooltip]="false"
                                    [clickable]="false"
                                    [title]="chatParticipant.title"
                                    [name]="
                                      chatParticipant.firstName +
                                      ' ' +
                                      chatParticipant.lastName
                                    "
                                    [name_verified_as]="
                                      chatParticipant.legalFirstName +
                                      ' ' +
                                      chatParticipant.lastName
                                    "
                                    [userId]="chatParticipant.userId"
                                    [hasImage]="!!chatParticipant.profilePic"
                                  ></app-badge>
                                </div>
                              }
                            </div>
                            @if (type === "Chat" && !isBlocked) {
                              <div
                                class="wave-cta celo-cursor-pointer"
                                role="button"
                                (click)="wave()"
                              >
                                <div class="subtitle underline-on-hover">
                                  Start a conversation with a wave
                                </div>
                                <div class="wave">👋</div>
                                <button
                                  mat-button
                                  class="celo-secondary-button uppercase mb-2"
                                >
                                  WAVE
                                </button>
                              </div>
                            }
                            @if (type === "SelfChat") {
                              <div class="self-chat">
                                <button
                                  mat-button
                                  class="celo-secondary-button uppercase mb-2"
                                  (click)="openConversationInfo()"
                                >
                                  EDIT PROFILE
                                </button>
                                <div class="subtitle self-chat-subtitle">
                                  Welcome to your private space. Take notes,
                                  draft messages, keep links and images or just
                                  talk to yourself 😉
                                </div>
                              </div>
                            }
                          </div>
                        }
                        @if (
                          type !== "Chat" &&
                          type !== "SelfChat" &&
                          type !== "TeamChat"
                        ) {
                          <div class="conversation-cta appear_1">
                            <div
                              class="icon celo-cursor-pointer"
                              (click)="openConversationInfo(); sidenav.open()"
                            >
                              <app-celo-avatar
                                [width]="90"
                                [height]="90"
                                [badgeSize]="30"
                                [type]="type"
                                [showBadge]="
                                  externalChatParticipant ? false : true
                                "
                                [participant]="externalChatParticipant"
                                [conversationPictureUri]="
                                  !!conversation.photoId && !leftChat
                                    ? conversationProfileUri
                                    : null
                                "
                              ></app-celo-avatar>
                            </div>
                            <div
                              class="name celo-cursor-pointer"
                              (click)="openConversationInfo(); sidenav.open()"
                            >
                              <div class="name-text underline-on-hover">
                                {{ name }}
                              </div>
                              @if (externalChatParticipant) {
                                <div class="badge-icon">
                                  &nbsp;<app-badge
                                    class="inline-block"
                                    [size]="26"
                                    [isExternal]="true"
                                  ></app-badge>
                                </div>
                              }
                            </div>
                            <div
                              class="subtitle celo-cursor-pointer underline-on-hover"
                              (click)="openConversationInfo(); sidenav.open()"
                            >
                              {{
                                activeOtherParticipants.length +
                                  (leftChat ? 0 : 1)
                              }}
                              participant
                              @if (
                                activeOtherParticipants.length +
                                  (leftChat ? 0 : 1) !==
                                1
                              ) {
                                <span>s</span>
                              }
                            </div>
                            @if (
                              conversation.invitation &&
                              conversation.invitation.uri &&
                              conversation.type !== "External"
                            ) {
                              <div
                                class="invitation-cta"
                                (click)="
                                  copy(conversation.invitation.uri);
                                  copyEvent('chat_header')
                                "
                              >
                                <button
                                  mat-button
                                  class="celo-secondary-button uppercase mb-2"
                                >
                                  copy {{ type }} invite link
                                </button>
                                <div
                                  class="subtitle underline-on-hover celo-cursor-pointer"
                                >
                                  Share the invite link to invite others to this
                                  <span class="lowercase">{{ type }}</span
                                  >.
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }
                    <app-messages-list
                      (selectMessage)="openMessageStatus($event)"
                      (quote_clicked)="quoteMessage($event)"
                      (forward)="forwardMessage($event)"
                      (copyMessage)="copyMessage($event)"
                      (delete)="deleteMessage($event)"
                      [messages]="messages"
                      [forceChangeDetection]="messages.length"
                      [conversationId]="id"
                      [patientId]="patientId"
                      [pMap]="pMap"
                      [userAccount]="userAccount"
                      [conversationType]="type"
                      [isOnDND]="isOnDND"
                      [isBlocked]="isBlocked"
                      [isConversationAdmin]="isConversationAdmin"
                      [isActiveParticipant]="isActiveParticipant"
                    ></app-messages-list>
                  </div>
                  @if (loadingMoreBottom) {
                    <div class="loading-more-bottom">
                      <div class="spinner more">
                        <mat-spinner
                          diameter="20"
                          strokeWidth="2"
                        ></mat-spinner>
                      </div>
                    </div>
                  }
                  <div #bottom></div>
                </div>
              }
              @if (
                !userAccount?.userId || !conversation || !pMap || !messages
              ) {
                <div class="fh loading">
                  <div class="spinner">
                    <app-empty-state
                      [isLoading]="true"
                      [no_message]="true"
                      [diameter]="60"
                    ></app-empty-state>
                  </div>
                </div>
              }
              @if (
                messageId &&
                !loadingMoreBottom &&
                !bottomReached &&
                !initialLoading
              ) {
                <div class="load-more-buttons">
                  <button mat-button (click)="loadMoreBottom()">
                    Load more...
                  </button>
                </div>
              }
            </div>
            @if (!messageId && enableScrollDown) {
              <div
                class="bottom-buttons"
                [style.bottom.px]="30 + bottom_bar.offsetHeight"
              >
                <button
                  mat-mini-fab
                  (click)="scrollToBottom()"
                  class="grow_0 scroll-to-bottom pointer_events"
                >
                  <mat-icon>keyboard_arrow_down</mat-icon>
                </button>
                @if (newMessageIds.length) {
                  <div class="new-messages-container">
                    <button
                      mat-button
                      (click)="scrollToBottom()"
                      class="new-messages appear_1 pointer_events"
                    >
                      <mat-icon>keyboard_arrow_down</mat-icon>
                      <span
                        >{{ newMessageIds.length }} new message
                        @if (newMessageIds.length > 1) {
                          <span>s</span>
                        }
                      </span>
                    </button>
                  </div>
                }
              </div>
            }

            <div #bottom_bar class="bottom_bar">
              @if (
                conversation &&
                !leftChat &&
                !isTeamInactive &&
                (isTeamChat ||
                  (!chatParticipant?.blockedByMe?.isBlocked &&
                    !chatParticipant?.blockedMe?.isBlocked)) &&
                (type !== "Chat" ||
                  conversation.isReal !== false ||
                  chatParticipant?.connection?.state === "Accepted" ||
                  hasCommanWorkspace)
              ) {
                <div class="appear_1">
                  <app-messages-bottom-text-bar
                    [pMap]="pMap"
                    [userAccount]="userAccount"
                    [conversationId]="id"
                    [conversation]="conversation"
                    [quotedMessage]="quotedMessage"
                    [uploader]="uploader"
                    [conversationType]="type"
                    [participants]="participants"
                    [userAccount]="userAccount"
                    (addPhotos)="addPhotos()"
                    (attachFiles)="attachFiles()"
                    (submitMessage)="submitMessage($event)"
                    (submitMessageMultiple)="submitMessageMultiple($event)"
                    (changeMessage)="changeMessage($event)"
                    (cancelQuote)="resetQuote()"
                    (sendAudio)="sendAudioMessage($event)"
                  >
                  </app-messages-bottom-text-bar>
                </div>
              }

              @if (leftChat || isTeamInactive) {
                <div class="left-chat appear_1">
                  @if (isTeamInactive) {
                    This role is unavailable to contact on Celo.
                  } @else {
                    You can't send messages in this
                    <span class="lowercase">{{
                      type === "TeamChat"
                        ? "chat"
                        : type === "External"
                          ? "conversation"
                          : type
                    }}</span>
                    because you're no longer a participant.
                  }
                </div>
              }

              @if (!isTeamChat) {
                @if (chatParticipant?.blockedByMe?.isBlocked) {
                  <div class="blocked-chat appear_1">
                    You need to unblock this user before contacting them.
                  </div>
                } @else {
                  @if (
                    conversation?.isReal === false &&
                    chatParticipant?.connection?.state !== "Accepted" &&
                    !hasCommanWorkspace
                  ) {
                    <div class="blocked-chat appear_1">
                      Connect with this user to contact them.
                    </div>
                  }
                  @if (
                    chatParticipant?.blockedMe?.isBlocked &&
                    !(conversation?.isReal === false && !hasCommanWorkspace)
                  ) {
                    <div class="blocked-chat appear_1">
                      This user is unavailable to contact on Celo.
                      <a class="celo-link" (click)="userUnavailableDialog()"
                        >Learn more.</a
                      >
                    </div>
                  }
                }
              }
            </div>
          </div>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</div>

@if (!leftChat && uploader && uploader.queue.length !== 0) {
  <div class="container-grid appear_1">
    <app-file-upload-preview
      (closeMe)="handleUploadClose()"
      (uploaded)="handleUploadSubmitted()"
      [type]="'Multi'"
      [uploader]="uploader"
      [isInSecureLibrary]="false"
      [refreshCount]="uploadRefreshCount"
      [patient]="uploadDraft.patient"
      (items)="handleItemsChange($event)"
      [selectedItemIndex]="uploadDraft.selectedItemIndex"
      (selectedItemIndexChange)="handleSelectedItemsIndexChange($event)"
    >
    </app-file-upload-preview>
  </div>
}
